import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b899246e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "items-center justify-between flex" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo text-xl flex-center" }, " GPT Craft ", -1))
const _hoisted_3 = { class: "links flex-center" }
const _hoisted_4 = ["title"]
const _hoisted_5 = {
  key: 2,
  class: "ml-4",
  href: "#playground"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: "24",
  height: "24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#fff",
    d: "M4 11h16v2H4zm0-5h16v2H4zm0 10h16v2H4z"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LogIn = _resolveComponent("LogIn")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.user)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", {
              class: _normalizeClass(["user mr-2", {'text-yellow-500': _ctx.isModer && !_ctx.isAdmin, 'text-red-500': _ctx.isAdmin}]),
              title: `You have ${_ctx.left} requests left`
            }, _toDisplayString(_ctx.user.displayName) + " (" + _toDisplayString(_ctx.left) + ")", 11, _hoisted_4),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
            }, "Logout")
          ], 64))
        : (_openBlock(), _createBlock(_component_LogIn, { key: 1 })),
      (_ctx.$route.path === '/')
        ? (_openBlock(), _createElementBlock("a", _hoisted_5, "Playground"))
        : _createCommentVNode("", true),
      (_ctx.$route.path !== '/settings')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 3,
            class: "ml-4",
            to: "/settings"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.$route.path !== '/')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 4,
            class: "ml-4",
            to: "/"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Home")
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}